"use client";

import type { ReactNode } from "react";

import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

type TextLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
};

export const TextLink = ({ href, children, className }: TextLinkProps) => {
  const classNames = cn("text-brand hover:underline", className);

  if (href.startsWith("http") || href.startsWith("mailto:")) {
    return (
      <a href={href} className={classNames}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} className={classNames}>
      {children}
    </Link>
  );
};
